var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.1875 1.875H20.0625V0H18.1875V1.875H5.8125V0H3.9375V1.875H2.8125C1.26169 1.875 0 3.13669 0 4.6875V21.1875C0 22.7383 1.26169 24 2.8125 24H21.1875C22.7383 24 24 22.7383 24 21.1875V4.6875C24 3.13669 22.7383 1.875 21.1875 1.875ZM22.125 21.1875C22.125 21.7044 21.7044 22.125 21.1875 22.125H2.8125C2.29556 22.125 1.875 21.7044 1.875 21.1875V8.8125H22.125V21.1875ZM22.125 6.9375H1.875V4.6875C1.875 4.17056 2.29556 3.75 2.8125 3.75H3.9375V5.625H5.8125V3.75H18.1875V5.625H20.0625V3.75H21.1875C21.7044 3.75 22.125 4.17056 22.125 4.6875V6.9375Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 10.7812H3.5625V12.6562H5.4375V10.7812Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 10.7812H7.3125V12.6562H9.1875V10.7812Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 10.7812H11.0625V12.6562H12.9375V10.7812Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6875 10.7812H14.8125V12.6562H16.6875V10.7812Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 10.7812H18.5625V12.6562H20.4375V10.7812Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 14.5312H3.5625V16.4062H5.4375V14.5312Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 14.5312H7.3125V16.4062H9.1875V14.5312Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 14.5312H11.0625V16.4062H12.9375V14.5312Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6875 14.5312H14.8125V16.4062H16.6875V14.5312Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4375 18.2812H3.5625V20.1562H5.4375V18.2812Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1875 18.2812H7.3125V20.1562H9.1875V18.2812Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 18.2812H11.0625V20.1562H12.9375V18.2812Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6875 18.2812H14.8125V20.1562H16.6875V18.2812Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 14.5312H18.5625V16.4062H20.4375V14.5312Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon2);
export default __webpack_public_path__ + "static/media/calendar-icon2.ea1fb71fa130ea5b7f73d361f04a06e4.svg";
export { ForwardRef as ReactComponent };